import React from 'react'
import SiteMetadata from 'src/components/SiteMetadata/SiteMetadata'
import { GlobalStyle } from 'src/styles/globalStyles'



// GlobalStyle must render here (inside wrapPageElement) rather than in
// StoreProvider: the site's wrapRootElement wraps OUTSIDE
// gatsby-plugin-styled-components' StyleSheetManager, so global styles
// rendered there are never collected into the SSR HTML and only apply
// after client-side hydration.
const PageElement = ({
  element,
  props,
}: {
  element: React.ReactNode
  props: React.ComponentProps<typeof SiteMetadata>
}) => {
  return <><GlobalStyle /><SiteMetadata {...props} />{element}</>
}

export default PageElement
